import * as React from 'react';

import CrossIcon from '../../assets/Cross.svg';
import {Cell} from '../Cell/Cell';
import {ClassNameBuilder} from '../../utils/ClassNameBuilder';
import {Icon} from '../Icon/Icon';
import {IconButton} from '../IconButton/IconButton';

import * as Styles from './Header.module.scss';

interface Props {
    text?: string;
    image?: string | React.ReactElement;
    className?: string;
    onClose?: (event: React.MouseEvent) => void;
}

export const Header: React.FC<Props> = (props) => {
    const {text, image, className, onClose, children} = props;

    const containerClass = new ClassNameBuilder(Styles, 'header')
        .add(className)
        .toString();

    let headerIcon = undefined;
    if (typeof image === 'string') {
        headerIcon = <Icon src={image} />;
    } else if (image) {
        headerIcon = image;
    }

    return (
        <Cell className={containerClass} text={text} image={headerIcon}>
            {children}
            {onClose && <IconButton image={CrossIcon} onClick={onClose} dataId={'header-close-button'} />}
        </Cell>
    );
};
